enum SeoPageType{
  Static,
  Dinamic
}

export default SeoPageType
